module.exports = __webpack_public_path__ + "static/img/SmileAnimation_peach.9c42e56.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/smiles/SmileAnimation_peach.gif
// module id = lZW+
// module chunks = 0